(function () {
	'use strict';
	angular
		.module('app.setup')
		.directive('pipelineActionLogs', pipelineActionLogs);

	function pipelineActionLogs() {
		var titleAttr = globalConfig.user.userName.endsWith('@leandna.com')
			? 'View log and data download options'
			: 'View data download options';
		return {
			restrict: 'E',
			template: '<a title="' + titleAttr + '" href="#" ng-click="$event.preventDefault();vm.openModal()"><i class="fa fa-clipboard"></i></a>',
			scope: {
				factoryndx: '@',
				factory: '@',
				datatype: '@',
				daterequest: '@',
				datestart: '@',
				dateend: '@',
				instanceid: '@',
				jobid: '@',
				status: '@',
				logurl: '@',
				hass3path: '@',
				hass3globalfilepath: '@',
				jobexecutionarn: '@',
				pipelineexecutionarn: '@',
				passedHealthChecks: '@',
				awsaccountid: '@',
				awsregion: '@'
			},
			controller: pipelineActionLogsCtrl,
			controllerAs: 'vm'
		};
	}

	pipelineActionLogsCtrl.$inject = ['$rootScope', '$scope', '$uibModal', '$timeout', 'dataPipelineService', 'siteService'];
	function pipelineActionLogsCtrl($rootScope, $scope, $uibModal, $timeout, dataPipelineService, siteService) {
		var vm = this;
		vm.openModal = openModal;

		vm.factoryNdx = $scope.factoryndx;
		vm.factory = $scope.factory;
		vm.dataType = $scope.datatype;
		vm.dateRequest = $scope.daterequest;
		vm.dateStart = $scope.datestart;
		// adding 1 second to the end date for aws logs to encompass the entire job
		vm.dateEnd = (parseInt($scope.dateend) + 1000).toString();
		vm.instanceId = $scope.instanceid;
		vm.jobId = $scope.jobid;
		vm.status = $scope.status;
		vm.logUrl = $scope.logurl;
		vm.hasS3Path = $scope.hass3path;
		vm.hasS3GlobalFilePath = $scope.hass3globalfilepath;
		vm.jobExecutionArn = $scope.jobexecutionarn;
		vm.pipelineExecutionArn = $scope.pipelineexecutionarn;
		vm.passedHealthChecks = $scope.passedhealthchecks;
		vm.awsAccountId = $scope.awsaccountid;
		vm.awsRegion = $scope.awsregion;

		function openModal() {
			var modal = $uibModal.open({
				ariaLabelledBy: 'modal-title',
				ariaDescribedBy: 'modal-body',
				templateUrl: '/application/f/setup/pipeline-action-logs.html',
				controller: function () {
					var vmModal = this;
					var hasAccessForSite = siteService.hasAccessForSite(vm.factoryNdx);
					var isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin(vm.factoryNdx);
					var isLegacyLtUpload = vm.jobExecutionArn ? vm.jobExecutionArn.split(':')[6] === 'LT-legacy-upload-global' : false;
					var isNewWorld = vm.pipelineExecutionArn ? true : vm.jobExecutionArn ? true : false;
					var hasLcLog = vm.logUrl ? vm.logUrl.endsWith('.log') : false;
					vmModal.closeModal = closeModal;
					vmModal.dataType = vm.dataType;
					vmModal.factory = vm.factory;
					vmModal.jobType = vm.dataType === 'Procurement' ? 'Analytics Engine' : vm.dataType;
					vmModal.actions = [];
					vmModal.onDownloadFail = onDownloadFail;
					vmModal.showDownloadFailed = {};
					vmModal.showLogs = globalConfig.user.userName.endsWith('@leandna.com');

					if (vm.dataType === 'LeanDNA Connect') {
						if (hasLcLog && isLeanDNAAdmin){
							vmModal.actions.push(buildPipelineLogDownload('leandna connect'));
						}
						if (vm.instanceId.slice(0,3) === 'LC-'){
							vmModal.actions.push(buildAwsLogsAction('lc2-cloudwatch-logs'));
						}
					} else if (vm.dataType === 'LeanTransform') {
						pushLeanTransformLogActions();
					} else if (vm.dataType === 'LeanSync') {
						if (hasAccessForSite) {
							vmModal.actions.push(buildPipelineLogDownload('leansync'));
						}
						if (isLeanDNAAdmin) {
							vmModal.actions.push(buildAwsLogsAction('LeanSync'));
							vmModal.actions.push(buildAwsLogsAction('messages'));
						}
					} else if (vm.dataType === 'Procurement') {
						buildNewWorldJobs();
						if (!isNewWorld) {
							vmModal.actions.push(buildAwsLogsAction('analytics/analytics.log'));
							vmModal.actions.push(buildAwsLogsAction('messages'));
						}
					} else if (vm.dataType === 'LeanLoad') {
						if (vm.status !== 'RUNNING' && hasAccessForSite && vm.hasS3Path === 'true') {
							vmModal.actions.push(buildPipelineLogDownload('leanload', false, isNewWorld));
						}
						if (isNewWorld) {
							vmModal.actions.push(buildAwsLogsAction('messages'));
						}
						if (isLeanDNAAdmin) {
							buildNewWorldJobs();
							if (!isNewWorld) {
								vmModal.actions.push(buildAwsLogsAction('messages'));
							}
						}
					}

					function pushLeanTransformLogActions() {
						vmModal.actions.push(buildPipelineLogDownload('site'));
						if (!isLeanDNAAdmin)
							return;

						if (isNewWorld && !isLegacyLtUpload) {
							buildNewWorldJobs();
						}
						// Display new world job actions after pipeline log downloads
						else {
							if (hasAccessForSite) {
								vmModal.actions.push(buildPipelineLogDownload('site', true));
								vmModal.actions.push(buildPipelineLogDownload('global'));
							}
							buildNewWorldJobs();
							vmModal.actions.push(buildAwsLogsAction('LeanTransform'));
						}
						vmModal.actions.push(buildAwsLogsAction('messages'));
					}
					function buildNewWorldJobs() {
						if (vm.pipelineExecutionArn) {
							vmModal.actions.push(buildSfnExecutionAction(vm.pipelineExecutionArn));
							buildInsightLogsAction(vm.pipelineExecutionArn);
						}

						if (vm.jobExecutionArn) {
							vmModal.actions.push(buildSfnExecutionAction(vm.jobExecutionArn));
							var jobType = vm.dataType === 'Procurement' ? 'casm' : undefined;
							buildInsightLogsAction(vm.jobExecutionArn, jobType);
						}
					}

					function buildPipelineLogDownload(dataType, postProcessed, isNewWorld){
						var displayType = vm.jobExecutionArn && !isLegacyLtUpload ? 'extract' : postProcessed ? 'post-processed ' + dataType : dataType;
						return {
							type: 'download',
							factoryNdx: vm.factoryNdx,
							href: dataPipelineService.getDownloadDataPath(
								dataType, vm.factoryNdx, vm.jobId, vm.logUrl, vm.dateRequest, vm.dateEnd, vm.hasS3Path, vm.hasS3GlobalFilePath, postProcessed),
							dataType: isNewWorld ? dataType : displayType,
							requestDate: vm.dateRequest
						};
					}

					function buildAwsLogsAction(dataType) {
						if(vm.instanceId && (vm.instanceId.charAt(0) === 'i') || (dataType === 'lc2-cloudwatch-logs')) {
							vmModal.showDownloadFailed[dataType] = false;
							return {
								type: 'aws',
								href: dataPipelineService.getAwsLogsUrl(vm.awsRegion,vm.awsAccountId,vm.instanceId, dataType, vm.dateStart, vm.dateEnd, vm.factoryNdx),
								logGroup: dataPipelineService.getAwsLogsGroup(dataType),
								cli: dataPipelineService.getAwsLogsCli(vm.awsRegion,vm.instanceId, dataType, vm.dateStart, vm.dateEnd, vm.factoryNdx),
								icon: (dataType === 'LeanTransform' || dataType === 'LeanSync') ? 'fa-external-link-square' : 'fa-external-link'
							};
						}
						return {type: ''};
					}

					function buildSfnExecutionAction(executionArn) {
						return {
							type: 'sfn',
							href: dataPipelineService.getSfnExecutionUrl(vm.awsRegion, executionArn),
							machineName: executionArn.split(':')[6],
							cli: dataPipelineService.getSfnExecutionCli(vm.awsRegion, executionArn),
							icon: 'fa-external-link-square'
						};
					}

					function buildInsightLogsAction(executionArn, executionType) {
						dataPipelineService
							.getInsightLogsUrl(
								vm.awsRegion,
								vm.factoryNdx,
								vm.jobId,
								executionArn,
								executionType
							)
							.then(function (response) {
								if (response !== '') {
									vmModal.actions.push({
										type: 'insight',
										href: response,
										machineName: executionArn.split(':')[6],
										icon: 'fa-external-link-square'
									});
								}
							});
					}

					function onDownloadFail(dataTypeObject) {
						var dataType = dataTypeObject.dataType;
						$timeout(function() {vmModal.showDownloadFailed[dataType] = true;});
						$timeout(function () {
							vmModal.showDownloadFailed[dataType] = false;
						}, 3000);
					}

					function closeModal() {
						modal.close('cancel');
					}
				},
				controllerAs: 'vm'
			});
		}
	};
})();
